<label class="inline-flex items-center gap-2 cursor-pointer select-none">
	<input
		type="checkbox"
		class="sr-only peer"
		[checked]="checked()"
		[disabled]="disabled()"
		(change)="toggle()"
	/>

	<!-- Custom UI -->
	<div
		class="inline-block h-5 w-5 rounded border-2 transition-colors duration-200 text--on-primary"
		[style.background]="
			checked() ? 'linear-gradient(135deg, var(--primary) 0%, #dc2626 100%)' : null
		"
		[class.border-outline]="!checked()"
		[class.border-2]="!checked()"
		[class.bg-surface-container-highest]="!checked()"
		[class.opacity-50]="disabled()"
	>
		<!-- Checkmark -->
		@if (checked()) {
			<i class="bi bi-check-lg relative bottom-0.5 left-0.5"></i>
		}
	</div>

	<!-- Label content -->
	<span class="text-sm text-on-surface">
		<ng-content />
	</span>
</label>
